import React, { memo } from 'react'
import PlayList from './cpms/play-list'
import LyricPanel from './cpms/lyric-panel'
import PlayHeader from './cpms/play-header'
import { PanelWrapper } from './style'

export default memo(function AppPlayPanel() {
    return (
        <PanelWrapper>
            <PlayHeader />
            <div className="main">
                <img
                    className="image"
                    src="https://p4.music.126.net/qeN7o2R3_OTPhghmkctFBQ==/764160591569856.jpg"
                    alt=""
                />
                <PlayList />
                <LyricPanel />
            </div>
        </PanelWrapper>
    )
})
